import { render, staticRenderFns } from "./otherJobItem.vue?vue&type=template&id=25ed9c1d&scoped=true&"
import script from "./otherJobItem.vue?vue&type=script&lang=js&"
export * from "./otherJobItem.vue?vue&type=script&lang=js&"
import style0 from "./otherJobItem.vue?vue&type=style&index=0&id=25ed9c1d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed9c1d",
  null
  
)

export default component.exports